module.exports = __webpack_public_path__ + "img/pip3.6ec7b31f.jpg";